import { format } from "date-fns" ;

export const dateFormatDDMMMYYYY = (data)=>{
    return format(data,"dd-MMM-yyyy");
}

export const dateFormateHHMMA = (data)=>{
    return format(Date.parse(data),"hh:mm a");
}